import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Menu(theme: Theme) {
  return {
    MuiMenuItem: {
      defaultProps: {},
      styleOverrides: {
        root: {
          padding: '8px 16px',
          gap: '8px',
          fontWeight: 500,
        },
      },
    },
    MuiMenu: {
      defaultProps: {
        sx: {},
      },
      styleOverrides: {
        root: {
          '& .MuiList-root': {
            padding: 0,
          },
          '& .MuiPaper-root': {
            padding: 0,
            borderRadius: '6px',
            border: `1px solid ${theme.palette.divider}`,
            boxShadow:
              '0px 2px 8px -2px rgba(16, 24, 40, 0.06), 0px 6px 12px -4px rgba(16, 24, 40, 0.08) !important',
          },
        },
      },
    },
  }
}
